import { Map as ImmutableMap, fromJS } from 'immutable';
import { useMemo } from 'react';
import { ReportingILSStrategyBuilder } from 'customer-data-filters-ui/public/strategies';
import { hasObjectTypeId } from '../../../utils/source-utils';
// @ts-expect-error untyped import
import { toDSFieldRecord } from '../xo-filter-utils';
import { getEventDateFilterProperty } from '../components/event-date-filter/event-date-filter-property';
import PropertyRecord from 'customer-data-objects/property/PropertyRecord';
// @ts-expect-error untyped import
import { EVENT_DATE_PROPERTY_NAME } from '../event-date-interval-utils';
export const useSnowflakeEventDateStrategy = ({
  source,
  shouldUseLegacyDateFilter = false
}) => {
  const dataType = hasObjectTypeId(source) ? source.objectTypeId : source.dataSourceId;
  const strategy = useMemo(() => {
    const fieldRecord = toDSFieldRecord(PropertyRecord(fromJS(getEventDateFilterProperty())), source);
    const updatedProps = ImmutableMap({
      [EVENT_DATE_PROPERTY_NAME]: fieldRecord
    });
    return ReportingILSStrategyBuilder({
      getField: (_, id, originalField) => {
        return updatedProps.get(id) || originalField;
      },
      getFields: () => updatedProps,
      getFilterFamilyName: () => dataType,
      getFilterFamilyObjectName: () => dataType,
      reportingFilterContext: 'snowflake_event',
      supportsLegacyILSDateTimeFilters: shouldUseLegacyDateFilter,
      isIncludeObjectsWithNoValueSetCheckboxEnabled: true
    });
  }, [dataType, source, shouldUseLegacyDateFilter]);
  return strategy;
};